<template>
  <b-modal :id="modalId" :title="$t('receiptMatcher.ignoreModalTitle')" size="lg" @hidden="resetModal">
    <p class="ignoreModalExplanation">{{ $t('receiptMatcher.ignoreModalExplanation') }}</p>
    <template #modal-footer>
      <b-button variant="secondary" class="ignoreOnceButton" @click="onIgnoreOnce">
        {{ $t('receiptMatcher.ignoreModalIgnoreOnce') }}
      </b-button>
      <b-button variant="primary" @click="onAddToBlacklist">
        {{ $t('receiptMatcher.ignoreModalAddToBlacklist') }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'SheetRowIgnoreModal',
  props: {
    modalId: {
      type: String,
      default: 'sheet-row-ignore-modal',
    },
  },
  methods: {
    showModal() {
      this.$bvModal.show(this.modalId)
    },
    hideModal() {
      this.$bvModal.hide(this.modalId)
    },
    resetModal() {
      // Nothing to reset
    },
    onIgnoreOnce() {
      this.hideModal()
      this.$emit('confirmed', false)
    },
    onAddToBlacklist() {
      this.hideModal()
      this.$emit('confirmed', true)
    },
  },
}
</script>

<style scoped>
.ignoreModalExplanation {
  color: #888;
  font-size: 0.85rem;
  margin-bottom: 0;
}

/* The "No, ignore once" button gets a grey fill, like the generic
   secondary buttons in the create wine modal / supplier delete modal. */
.ignoreOnceButton {
  background-color: var(--color-gray-200);
  border-color: var(--color-gray-200);
  color: var(--color-white);
}
</style>
